export default __webpack_public_path__ + "static/media/areas.cb2c89ef.svg";